import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  pulse?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  fullWidth = false,
  pulse = false,
  children,
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={pulse ? {
    boxShadow: ['0 0 0 0 rgba(22, 163, 74, 0.7)', '0 0 0 10px rgba(22, 163, 74, 0)']
  } : {}} transition={pulse ? {
    duration: 1.5,
    repeat: Infinity,
    repeatType: 'loop'
  } : {}} className={cn('inline-flex items-center justify-center rounded-lg font-bold text-white transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none', 'bg-[#16a34a] hover:bg-[#15803d] text-lg md:text-xl py-4 px-8 shadow-lg uppercase tracking-wide', fullWidth && 'w-full', className)} {...props} data-id="element-191">
      {children}
    </motion.button>;
}